


  
  

  var faBrainCircuit = {
    prefix: 'fasl',
    iconName: 'brain-circuit',
    icon: [
      512,
      512,
      [],
      'e0c6',
      
      'M192 32l48 0 0 48 0 48-27.3 0c-6.2-14.1-20.3-24-36.7-24c-22.1 0-40 17.9-40 40s17.9 40 40 40c16.4 0 30.5-9.9 36.7-24l27.3 0 0 112-80 0-16 0 0 16 0 27.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-11.3 64 0 0 128 0 48-48 0c-20.4 0-37.9-12.8-44.8-30.8L142.5 437l-12.9 2.2c-3.1 .5-6.3 .8-9.5 .8c-30.9 0-56-25.1-56-56c0-7.8 1.6-15.2 4.4-21.8l5.3-12.6-11.6-7.2C44 331 32 310.9 32 288c0-19.1 8.4-36.3 21.7-48.1l7.9-7-3.3-10c-1.5-4.7-2.4-9.7-2.4-15c0-20.4 12.8-38 30.9-44.9l12.5-4.8-2.5-13.2c-.6-3-.9-6-.9-9.2c0-22.4 15.4-41.3 36.2-46.5l11-2.8 1.1-11.3C146.5 51.1 167 32 192 32zm80 128l64 0 0 27.3c-14.1 6.2-24 20.3-24 36.7c0 22.1 17.9 40 40 40s40-17.9 40-40c0-16.4-9.9-30.5-24-36.7l0-43.3 0-16-16 0-80 0 0-48 0-48 48 0c25 0 45.5 19.1 47.8 43.4l1.1 11.3 11 2.8C400.6 94.7 416 113.6 416 136c0 3.1-.3 6.2-.9 9.2l-2.5 13.2 12.5 4.8C443.2 170 456 187.6 456 208c0 5.2-.8 10.3-2.4 15l-3.3 10 7.9 7C471.6 251.7 480 268.9 480 288c0 22.9-12 43-30.2 54.3l-11.6 7.2 5.3 12.6c2.8 6.7 4.4 14.1 4.4 21.8c0 30.9-25.1 56-56 56c-3.3 0-6.5-.3-9.5-.8L369.5 437l-4.7 12.2c-6.9 18-24.4 30.8-44.8 30.8l-48 0 0-48 0-48 59.3 0c6.2 14.1 20.3 24 36.7 24c22.1 0 40-17.9 40-40s-17.9-40-40-40c-16.4 0-30.5 9.9-36.7 24L272 352l0-192zM192 512l48 0 16 0 16 0 48 0c29.6 0 55.5-16.1 69.3-40c.9 0 1.8 0 2.7 0c48.6 0 88-39.4 88-88c0-7.6-1-15-2.8-22c21.2-17.6 34.8-44.2 34.8-74c0-25.1-9.6-48-25.4-65c.9-4.9 1.4-9.9 1.4-15c0-29.6-16.1-55.5-40-69.3c0-.9 0-1.8 0-2.7c0-33.6-20.7-62.4-50.1-74.2C389.7 26.4 357.9 0 320 0L272 0 256 0 240 0 192 0c-37.9 0-69.7 26.4-77.9 61.8C84.7 73.6 64 102.4 64 136c0 .9 0 1.8 0 2.7C40.1 152.5 24 178.4 24 208c0 5.1 .5 10.1 1.4 15C9.6 240 0 262.9 0 288c0 29.8 13.6 56.4 34.8 74C33 369 32 376.4 32 384c0 48.6 39.4 88 88 88c.9 0 1.8 0 2.7 0c13.8 23.9 39.7 40 69.3 40zM176 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM160 336a16 16 0 1 1 0 32 16 16 0 1 1 0-32zM336 224a16 16 0 1 1 32 0 16 16 0 1 1 -32 0zm32 128a16 16 0 1 1 0 32 16 16 0 1 1 0-32z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fasl',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM191.4 168.8l-22.6 22.6 11.3 11.3L233.4 256l-53.3 53.3-11.3 11.3 22.6 22.6 11.3-11.3L256 278.6l53.3 53.3 11.3 11.3 22.6-22.6-11.3-11.3L278.6 256l53.3-53.3 11.3-11.3-22.6-22.6-11.3 11.3L256 233.4l-53.3-53.3-11.3-11.3z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faTriangleExclamation = {
    prefix: 'fasl',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M18.3 448L0 480l36.9 0 438.3 0 36.9 0-18.3-32L274.4 64.2 256 32 237.6 64.2 18.3 448zm438.6 0L55.1 448 256 96.5 456.9 448zM240 320l0 16 32 0 0-16 0-128-32 0 0 128zm40 96l0-48-48 0 0 48 48 0z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faCalendar = {
    prefix: 'fasl',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M128 0l0 16 0 48 192 0 0-48 0-16 32 0 0 16 0 48 64 0 32 0 0 32 0 64 0 32 0 288 0 32-32 0L32 512 0 512l0-32L0 192l0-32L0 96 0 64l32 0 64 0 0-48L96 0l32 0zM416 192L32 192l0 288 384 0 0-288zm0-96L32 96l0 64 384 0 0-64z'
      
    ]
  };

  

  
  

  var faChevronRight = {
    prefix: 'fasl',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M310.6 256l-11.3 11.3-192 192L96 470.6 73.4 448l11.3-11.3L265.4 256 84.7 75.3 73.4 64 96 41.4l11.3 11.3 192 192L310.6 256z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fasl',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M9.4 256l11.3-11.3 192-192L224 41.4 246.6 64 235.3 75.3 54.6 256 235.3 436.7 246.6 448 224 470.6l-11.3-11.3-192-192L9.4 256z'
      
    ]
  };

  

  
  

  var faLinkHorizontalSlash = {
    prefix: 'fasl',
    iconName: 'link-horizontal-slash',
    icon: [
      640,
      512,
      ["chain-horizontal-slash"],
      'e1cc',
      
      'M32.5 10L19.9 .1 .1 25.3l12.6 9.9L607.8 502.2l12.6 9.9 19.8-25.2-12.6-9.9L32.5 10zM640 320c0-70.7-57.3-128-128-128l-32 0 0 32 32 0c53 0 96 43 96 96c0 24.2-8.9 46.3-23.7 63.1L609.5 403c19-22.3 30.5-51.3 30.5-83zM459.9 448l-40.5-32-83.5 0c-52.9 0-95.9-42.9-95.9-95.9c0-13.9 3-27.2 8.4-39.2l-25.7-20.3c-9.4 17.8-14.6 38.1-14.6 59.5C208 390.8 265.2 448 335.9 448l124.1 0zM400 191.9c0 13.9-3 27.2-8.4 39.2l25.7 20.3c9.4-17.8 14.6-38.1 14.6-59.5C432 121.2 374.8 64 304.1 64L180.1 64l40.5 32 83.5 0c52.9 0 95.9 42.9 95.9 95.9zm-344.3-63L30.5 109C11.5 131.4 0 160.3 0 192c0 70.7 57.3 128 128 128l32 0 0-32-32 0c-53 0-96-43-96-96c0-24.2 8.9-46.3 23.7-63.1z'
      
    ]
  };

  
    var faChainHorizontalSlash = faLinkHorizontalSlash;
  

  
  

  var faPlus = {
    prefix: 'fasl',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M240 64l0-16-32 0 0 16 0 176L32 240l-16 0 0 32 16 0 176 0 0 176 0 16 32 0 0-16 0-176 176 0 16 0 0-32-16 0-176 0 0-176z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faChevronDown = {
    prefix: 'fasl',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 406.6l11.3-11.3 192-192L470.6 192 448 169.4l-11.3 11.3L256 361.4 75.3 180.7 64 169.4 41.4 192l11.3 11.3 192 192L256 406.6z'
      
    ]
  };

  

  
  

  var faMagnifyingGlass = {
    prefix: 'fasl',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L510.5 487.9l-22.6 22.6L343.3 366z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faFile = {
    prefix: 'fasl',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M352 192l-144 0-16 0 0-16 0-144L32 32l0 448 320 0 0-288zm-5.3-32L224 37.3 224 160l122.7 0zM32 0L232 0 384 152l0 328 0 32-32 0L32 512 0 512l0-32L0 32 0 0 32 0z'
      
    ]
  };

  

  
  

  var faArrowsFromLine = {
    prefix: 'fasl',
    iconName: 'arrows-from-line',
    icon: [
      448,
      512,
      [],
      'e0a4',
      
      'M224 1.4l11.3 11.3 80 80L326.6 104 304 126.6l-11.3-11.3L240 62.6 240 176l0 16-32 0 0-16 0-113.4-52.7 52.7L144 126.6 121.4 104l11.3-11.3 80-80L224 1.4zm0 509.3l-11.3-11.3-80-80L121.4 408 144 385.4l11.3 11.3L208 449.4 208 336l0-16 32 0 0 16 0 113.4 52.7-52.7L304 385.4 326.6 408l-11.3 11.3-80 80L224 510.6zM16 240l416 0 16 0 0 32-16 0L16 272 0 272l0-32 16 0z'
      
    ]
  };

  

  
  

  var faGrid2Plus = {
    prefix: 'fasl',
    iconName: 'grid-2-plus',
    icon: [
      512,
      512,
      [],
      'e197',
      
      'M192 64L64 64l0 128 128 0 0-128zM64 32l128 0 32 0 0 32 0 128 0 32-32 0L64 224l-32 0 0-32L32 64l0-32 32 0zM192 320L64 320l0 128 128 0 0-128zM64 288l128 0 32 0 0 32 0 128 0 32-32 0L64 480l-32 0 0-32 0-128 0-32 32 0zM320 64l0 128 128 0 0-128L320 64zM288 32l32 0 128 0 32 0 0 32 0 128 0 32-32 0-128 0-32 0 0-32 0-128 0-32zM400 272l0 16 0 80 80 0 16 0 0 32-16 0-80 0 0 80 0 16-32 0 0-16 0-80-80 0-16 0 0-32 16 0 80 0 0-80 0-16 32 0z'
      
    ]
  };

  

  
  

  var faImages = {
    prefix: 'fasl',
    iconName: 'images',
    icon: [
      576,
      512,
      [],
      'f302',
      
      'M128 64l416 0 0 137.4-68.7-68.7L464 121.4l-11.3 11.3L304 281.4l-84.7-84.7L208 185.4l-11.3 11.3L128 265.4 128 64zm448 0l0-32-32 0L128 32 96 32l0 32 0 240 0 48 0 32 32 0 112 0c0 0 0 0 0 0l304 0 32 0 0-32 0-112c0 0 0 0 0-.1l0-176zM464 166.6l80 80L544 352l-265.4 0 36.7-36.7L464 166.6zM281.4 304l-48 48L128 352l0-41.4 80-80L281.4 304zM32 112l0-16L0 96l0 16L0 464l0 16 16 0 448 0 16 0 0-32-16 0L32 448l0-336zm232 48a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fasl',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M32 64l64 0 0 64-64 0 0-64zm0 160l64 0 0 64-64 0 0-64zM96 384l0 64-64 0 0-64 64 0z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faSliders = {
    prefix: 'fasl',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 400l0 32 16 0 64 0 0 32 0 32 32 0 96 0 32 0 0-32 0-32 256 0 16 0 0-32-16 0-256 0 0-32 0-32-32 0-96 0-32 0 0 32 0 32-64 0L0 400zm208 32l0 32-96 0 0-32 0-32 0-32 96 0 0 32 0 32zM0 240l0 32 16 0 256 0 0 32 0 32 32 0 96 0 32 0 0-32 0-32 64 0 16 0 0-32-16 0-64 0 0-32 0-32-32 0-96 0-32 0 0 32 0 32L16 240 0 240zM112 112l0 32 0 32 32 0 96 0 32 0 0-32 0-32 224 0 16 0 0-32-16 0L272 80l0-32 0-32-32 0-96 0-32 0 0 32 0 32L16 80 0 80l0 32 16 0 96 0zm32 0l0-32 0-32 96 0 0 32 0 32 0 32-96 0 0-32zM400 240l0 32 0 32-96 0 0-32 0-32 0-32 96 0 0 32z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faBallot = {
    prefix: 'fasl',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M416 32l0 448L32 480 32 32l384 0zM32 0L0 0 0 32 0 480l0 32 32 0 384 0 32 0 0-32 0-448 0-32L416 0 32 0zM160 112l0 32 16 0 176 0 16 0 0-32-16 0-176 0-16 0zm0 128l0 32 16 0 176 0 16 0 0-32-16 0-176 0-16 0zm0 128l0 32 16 0 176 0 16 0 0-32-16 0-176 0-16 0zM120 104l-48 0 0 48 48 0 0-48zM72 232l0 48 48 0 0-48-48 0zm48 128l-48 0 0 48 48 0 0-48z'
      
    ]
  };

  

  
  

  var faGear = {
    prefix: 'fasl',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M195 108c-13.2 5.4-25.5 12.6-36.7 21.2l-13.3 10.2-16-5.1-52-16.6L46.9 170.2l40.3 36.7 12.4 11.3-2.2 16.6c-.9 6.9-1.4 14-1.4 21.2s.5 14.3 1.4 21.2l2.2 16.6L87.2 305.1 46.9 341.8l30.2 52.4 52-16.6 16-5.1 13.3 10.2c11.2 8.6 23.5 15.8 36.7 21.2l15.5 6.4 3.6 16.4L225.8 480l60.5 0 11.7-53.3 3.6-16.4L317 404c13.2-5.4 25.5-12.6 36.7-21.2l13.3-10.2 16 5.1 52 16.6 30.2-52.4-40.3-36.7-12.4-11.3 2.2-16.6c.9-6.9 1.4-14 1.4-21.2s-.5-14.3-1.4-21.2l-2.2-16.6 12.4-11.3 40.3-36.7-30.2-52.4-52 16.6-16 5.1-13.3-10.2c-11.2-8.6-23.5-15.8-36.7-21.2l-15.5-6.4-3.6-16.4L286.2 32l-60.5 0L214.1 85.3l-3.6 16.4L195 108zM200 0L312 0l17.2 78.4c15.8 6.5 30.6 15.1 44 25.4l76.5-24.4 56 97-59.4 54.1c1.1 8.3 1.7 16.8 1.7 25.4s-.6 17.1-1.7 25.4l59.4 54.1-56 97-76.5-24.4c-13.4 10.3-28.2 18.9-44 25.4L312 512l-112 0-17.2-78.4c-15.8-6.5-30.6-15.1-44-25.4L62.3 432.5l-56-97 59.4-54.1C64.6 273.1 64 264.6 64 256s.6-17.1 1.7-25.4L6.3 176.5l56-97 76.5 24.4c13.4-10.3 28.2-18.9 44-25.4L200 0zM312 256a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm-144 0a88 88 0 1 1 176 0 88 88 0 1 1 -176 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faListTimeline = {
    prefix: 'fasl',
    iconName: 'list-timeline',
    icon: [
      512,
      512,
      [],
      'e1d1',
      
      'M144 96l22.6-22.6L208 32l208 0 32 0 0 32 0 64 0 32-32 0-208 0-41.4-41.4L144 96zm272 32l0-64L221.3 64l-32 32 32 32L416 128zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 0l22.6-22.6L208 352l208 0 32 0 0 32 0 64 0 32-32 0-208 0-41.4-41.4L144 416zm272 32l0-64-194.7 0-32 32 32 32L416 448zM166.6 278.6L144 256l22.6-22.6L208 192l272 0 32 0 0 32 0 64 0 32-32 0-272 0-41.4-41.4zm54.6 9.4L480 288l0-64-258.7 0-32 32 32 32z'
      
    ]
  };

  

  
  

  var faArrowDownAZ = {
    prefix: 'fasl',
    iconName: 'arrow-down-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-asc","sort-alpha-down"],
      'f15d',
      
      'M171.3 467.3L160 478.6l-11.3-11.3-88-88L49.4 368 72 345.4l11.3 11.3L144 417.4 144 48l0-16 32 0 0 16 0 369.4 60.7-60.7L248 345.4 270.6 368l-11.3 11.3-88 88zM352 288l128 0 16 0 0 16 0 8 0 6.1-4 4.5L380.5 448l99.5 0 16 0 0 32-16 0-128 0-16 0 0-16 0-8 0-6.1 4-4.5L451.5 320 352 320l-16 0 0-32 16 0zm17.5-96l-14.2 32-35 0 1.1-2.5 80-180 4.2-9.5 20.8 0 4.2 9.5 80 180 1.1 2.5-35 0-14.2-32-93 0zm78.8-32L416 87.4 383.7 160l64.5 0z'
      
    ]
  };

  
    var faSortAlphaAsc = faArrowDownAZ;
  
    var faSortAlphaDown = faArrowDownAZ;
  

  
  

  var faArrowDown19 = {
    prefix: 'fasl',
    iconName: 'arrow-down-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-asc","sort-numeric-down"],
      'f162',
      
      'M160 478.6l11.3-11.3 88-88L270.6 368 248 345.4l-11.3 11.3L176 417.4 176 48l0-16-32 0 0 16 0 369.4L83.3 356.7 72 345.4 49.4 368l11.3 11.3 88 88L160 478.6zM368 32l0 32 16 0 32 0 0 128-32 0-16 0 0 32 16 0 48 0 48 0 16 0 0-32-16 0-32 0 0-144 0-16-16 0-48 0-16 0zm60 360a52 52 0 1 1 0-104 52 52 0 1 1 0 104zm-84-52c0 46.4 37.6 84 84 84c2 0 3.9-.1 5.8-.2l-42.4 53.5c-.7 .9-1.2 1.7-1.7 2.7l40.4 0 61.7-77.9c13.1-16.5 20.2-37 20.2-58.1c0 0-.1 0-.1 0c.1-1.3 .1-2.7 .1-4c0-46.4-37.6-84-84-84s-84 37.6-84 84z'
      
    ]
  };

  
    var faSortNumericAsc = faArrowDown19;
  
    var faSortNumericDown = faArrowDown19;
  

  
  

  var faCircleInfo = {
    prefix: 'fasl',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM192 352l0 32 16 0 96 0 16 0 0-32-16 0-32 0 0-112 0-16-16 0-40 0-16 0 0 32 16 0 24 0 0 96-32 0-16 0zm88-168l0-48-48 0 0 48 48 0z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faTrash = {
    prefix: 'fasl',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M151.1 0L160 0 288 0l8.9 0 4.7 7.5L336.9 64l47.1 0L416 64l32 0 0 32-34.3 0L384 512 64 512 34.3 96 0 96 0 64l32 0 32.1 0 47.1 0L146.4 7.5 151.1 0zm-2.3 64l150.3 0-20-32L168.9 32l-20 32zM66.4 96L93.8 480l260.4 0L381.6 96 66.4 96z'
      
    ]
  };

  

  
  

  var faOctagonExclamation = {
    prefix: 'fasl',
    iconName: 'octagon-exclamation',
    icon: [
      512,
      512,
      [],
      'e204',
      
      'M32 338.7l0-165.5L173.3 32l165.5 0L480 173.3l0 165.5L338.7 480l-165.5 0L32 338.7zM160 0L0 160 0 352 160 512l192 0L512 352l0-192L352 0 160 0zM272 128l-32 0 0 16 0 128 0 16 32 0 0-16 0-128 0-16zM232 320l0 48 48 0 0-48-48 0z'
      
    ]
  };

  

  
  

  var faArrowUp19 = {
    prefix: 'fasl',
    iconName: 'arrow-up-1-9',
    icon: [
      576,
      512,
      ["sort-numeric-up"],
      'f163',
      
      'M368 32l16 0 48 0 16 0 0 16 0 144 32 0 16 0 0 32-16 0-48 0-48 0-16 0 0-32 16 0 32 0 0-128-32 0-16 0 0-32zM160 33.4l11.3 11.3 88 88L270.6 144 248 166.6l-11.3-11.3L176 94.6 176 464l0 16-32 0 0-16 0-369.4L83.3 155.3 72 166.6 49.4 144l11.3-11.3 88-88L160 33.4zM428 288a52 52 0 1 0 0 104 52 52 0 1 0 0-104zm-84 52c0-46.4 37.6-84 84-84s84 37.6 84 84c0 1.3 0 2.7-.1 4c0 0 .1 0 .1 0c0 21.1-7.1 41.6-20.2 58.1L430.1 480l-40.4 0c.5-.9 1-1.8 1.7-2.7l42.4-53.5c-1.9 .1-3.9 .2-5.8 .2c-46.4 0-84-37.6-84-84z'
      
    ]
  };

  
    var faSortNumericUp = faArrowUp19;
  

  
  

  var faSpinnerThird = {
    prefix: 'fasl',
    iconName: 'spinner-third',
    icon: [
      512,
      512,
      [],
      'f3f4',
      
      'M477.7 384c21.8-37.7 34.3-81.4 34.3-128C512 114.6 397.4 0 256 0l0 32c123.7 0 224 100.3 224 224c0 40.8-10.9 79.1-30 112l27.7 16z'
      
    ]
  };

  

  
  

  var faCircleEllipsisVertical = {
    prefix: 'fasl',
    iconName: 'circle-ellipsis-vertical',
    icon: [
      512,
      512,
      [],
      'e10b',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm232 72l48 0 0 48-48 0 0-48zm0-192l48 0 0 48-48 0 0-48zm0 144l0-48 48 0 0 48-48 0z'
      
    ]
  };

  

  
  

  var faCalendarArrowUp = {
    prefix: 'fasl',
    iconName: 'calendar-arrow-up',
    icon: [
      448,
      512,
      ["calendar-upload"],
      'e0d1',
      
      'M128 16l0-16L96 0l0 16 0 48L32 64 0 64 0 96l0 64 0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-288 0-32 0-64 0-32-32 0-64 0 0-48 0-16L320 0l0 16 0 48L128 64l0-48zM32 192l384 0 0 288L32 480l0-288zm0-96l384 0 0 64L32 160l0-64zM208 408l0 16 32 0 0-16 0-121.4 52.7 52.7L304 350.6 326.6 328l-11.3-11.3-80-80L224 225.4l-11.3 11.3-80 80L121.4 328 144 350.6l11.3-11.3L208 286.6 208 408z'
      
    ]
  };

  
    var faCalendarUpload = faCalendarArrowUp;
  

  
  

  var faArrowsToLine = {
    prefix: 'fasl',
    iconName: 'arrows-to-line',
    icon: [
      448,
      512,
      [],
      'e0a7',
      
      'M224 198.6l11.3-11.3 80-80L326.6 96 304 73.4 292.7 84.7 240 137.4 240 16l0-16L208 0l0 16 0 121.4L155.3 84.7 144 73.4 121.4 96l11.3 11.3 80 80L224 198.6zM0 240l0 32 16 0 416 0 16 0 0-32-16 0L16 240 0 240zm235.3 84.7L224 313.4l-11.3 11.3-80 80L121.4 416 144 438.6l11.3-11.3L208 374.6 208 496l0 16 32 0 0-16 0-121.4 52.7 52.7L304 438.6 326.6 416l-11.3-11.3-80-80z'
      
    ]
  };

  

  
  

  var faCircleQuestion = {
    prefix: 'fasl',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168-72c0-30.9 25.1-56 56-56l56 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3l0 3.7 0 16-32 0 0-16 0-13.5 0-9.8 8.7-4.5 45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-56 0c-13.3 0-24 10.7-24 24l0 8-32 0 0-8zm64 136l48 0 0 48-48 0 0-48z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faClipboardCheck = {
    prefix: 'fasl',
    iconName: 'clipboard-check',
    icon: [
      384,
      512,
      [],
      'f46c',
      
      'M145.5 68c5.3-20.7 24.1-36 46.5-36s41.2 15.3 46.5 36l3.1 12L254 80l34 0 0 48-96 0-96 0 0-48 34 0 12.4 0 3.1-12zM192 0c-32.8 0-61 19.8-73.3 48L80 48 64 48l0 16 0 16L32 80 0 80l0 32L0 480l0 32 32 0 320 0 32 0 0-32 0-368 0-32-32 0-32 0 0-16 0-16-16 0-38.7 0C253 19.8 224.8 0 192 0zM320 144l0-32 32 0 0 368L32 480l0-368 32 0 0 32 0 16 16 0 112 0 112 0 16 0 0-16zM208 80a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm91.3 171.3L310.6 240 288 217.4l-11.3 11.3L160 345.4l-52.7-52.7L96 281.4 73.4 304l11.3 11.3 64 64L160 390.6l11.3-11.3 128-128z'
      
    ]
  };

  

  
  

  var faFolders = {
    prefix: 'fasl',
    iconName: 'folders',
    icon: [
      576,
      512,
      [],
      'f660',
      
      'M304 32L128 32 96 32l0 32 0 288 0 32 32 0 416 0 32 0 0-32 0-224 0-32-32 0L368 96 304 32zm64 96l176 0 0 224-416 0 0-288 162.7 0 54.6 54.6 9.4 9.4 13.3 0zM32 112l0-16L0 96l0 16L0 464l0 16 16 0 448 0 16 0 0-32-16 0L32 448l0-336z'
      
    ]
  };

  

  
  

  var faCalendarArrowDown = {
    prefix: 'fasl',
    iconName: 'calendar-arrow-down',
    icon: [
      448,
      512,
      ["calendar-download"],
      'e0d0',
      
      'M128 16l0-16L96 0l0 16 0 48L32 64 0 64 0 96l0 64 0 32L0 480l0 32 32 0 384 0 32 0 0-32 0-288 0-32 0-64 0-32-32 0-64 0 0-48 0-16L320 0l0 16 0 48L128 64l0-48zM32 192l384 0 0 288L32 480l0-288zm0-96l384 0 0 64L32 160l0-64zM240 256l0-16-32 0 0 16 0 121.4-52.7-52.7L144 313.4 121.4 336l11.3 11.3 80 80L224 438.6l11.3-11.3 80-80L326.6 336 304 313.4l-11.3 11.3L240 377.4 240 256z'
      
    ]
  };

  
    var faCalendarDownload = faCalendarArrowDown;
  

  
  

  var faArrowUpRightFromSquare = {
    prefix: 'fasl',
    iconName: 'arrow-up-right-from-square',
    icon: [
      512,
      512,
      ["external-link"],
      'f08e',
      
      'M336 0L320 0l0 32 16 0 121.4 0L212.7 276.7 201.4 288 224 310.6l11.3-11.3L480 54.6 480 176l0 16 32 0 0-16 0-160 0-16L496 0 336 0zM16 32L0 32 0 48 0 496l0 16 16 0 448 0 16 0 0-16 0-192 0-16-32 0 0 16 0 176L32 480 32 64l176 0 16 0 0-32-16 0L16 32z'
      
    ]
  };

  
    var faExternalLink = faArrowUpRightFromSquare;
  

  
  

  var faPuzzlePiece = {
    prefix: 'fasl',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M169.1 17.3C183.8 6.3 203.2 0 224 0s40.2 6.3 54.9 17.3S304 44.6 304 64c0 22.4-13.7 40.4-32 51.3l0 12.7 96 0 16 0 0 16 0 96 12.7 0c10.9-18.3 28.9-32 51.3-32c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-22.4 0-40.4-13.7-51.3-32L384 336l0 160 0 16-16 0-112 0-16 0 0-16 0-38.4 0-10.5 9.6-4.2C265 436.2 272 425.4 272 416c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1c0 9.4 7 20.2 22.4 26.9l9.6 4.2 0 10.5 0 38.4 0 16-16 0L16 512 0 512l0-16L0 320l0-16 16 0 38.4 0 10.5 0 4.2 9.6C75.8 329 86.6 336 96 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7S103.1 240 96 240c-9.4 0-20.2 7-26.9 22.4L64.9 272l-10.5 0L16 272 0 272l0-16L0 144l0-16 16 0 160 0 0-12.7c-18.3-10.9-32-28.9-32-51.3c0-19.4 10.5-35.8 25.1-46.7zm19.2 25.6C179.8 49.3 176 56.9 176 64c0 9.4 7 20.2 22.4 26.9l9.6 4.2 0 10.5 0 38.4 0 16-16 0L32 160l0 80 12.7 0c10.9-18.3 28.9-32 51.3-32c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9S115.4 368 96 368c-22.4 0-40.4-13.7-51.3-32L32 336l0 144 144 0 0-12.7c-18.3-10.9-32-28.9-32-51.3c0-19.4 10.5-35.8 25.1-46.7s34.1-17.3 54.9-17.3s40.2 6.3 54.9 17.3s25.1 27.3 25.1 46.7c0 22.4-13.7 40.4-32 51.3l0 12.7 80 0 0-160 0-16 16 0 38.4 0 10.5 0 4.2 9.6C427.8 329 438.6 336 448 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-9.4 0-20.2 7-26.9 22.4l-4.2 9.6-10.5 0L368 272l-16 0 0-16 0-96-96 0-16 0 0-16 0-38.4 0-10.5 9.6-4.2C265 84.2 272 73.4 272 64c0-7.1-3.8-14.7-12.3-21.1S238.5 32 224 32s-27.1 4.4-35.7 10.9z'
      
    ]
  };

  

  
  

  var faSort = {
    prefix: 'fasl',
    iconName: 'sort',
    icon: [
      320,
      512,
      ["unsorted"],
      'f0dc',
      
      'M32 190.2L160 75 288 190.2l0 1.7L32 192l0-1.7zM0 224l32 0 256 0 32 0 0-32 0-16L160 32 0 176l0 16 0 32zm32 97.8l0-1.8 256 0 0 1.8L160 437 32 321.8zM0 288l0 32 0 16L160 480 320 336l0-16 0-32-32 0L32 288 0 288z'
      
    ]
  };

  
    var faUnsorted = faSort;
  

  
  

  var faAddressCard = {
    prefix: 'fasl',
    iconName: 'address-card',
    icon: [
      576,
      512,
      [62140,"contact-card","vcard"],
      'f2bb',
      
      'M544 64l0 384L32 448 32 64l512 0zM32 32L0 32 0 64 0 448l0 32 32 0 512 0 32 0 0-32 0-384 0-32-32 0L32 32zM160 192a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm96 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM135.1 320l113.9 0 21.3 64 33.7 0-32-96-160 0L80 384l33.7 0 21.3-64zM352 160l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0zm0 64l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0zm0 64l-16 0 0 32 16 0 128 0 16 0 0-32-16 0-128 0z'
      
    ]
  };

  
    var faContactCard = faAddressCard;
  
    var faVcard = faAddressCard;
  

  
  

  var faCircleCheck = {
    prefix: 'fasl',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3L374.6 192 352 169.4l-11.3 11.3L224 297.4l-52.7-52.7L160 233.4 137.4 256l11.3 11.3 64 64L224 342.6l11.3-11.3 128-128z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faAnglesRight = {
    prefix: 'fasl',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M267.3 267.3L278.6 256l-11.3-11.3-160-160L96 73.4 73.4 96l11.3 11.3L233.4 256 84.7 404.7 73.4 416 96 438.6l11.3-11.3 160-160zm192 0L470.6 256l-11.3-11.3-160-160L288 73.4 265.4 96l11.3 11.3L425.4 256 276.7 404.7 265.4 416 288 438.6l11.3-11.3 160-160z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faImage = {
    prefix: 'fasl',
    iconName: 'image',
    icon: [
      512,
      512,
      [],
      'f03e',
      
      'M32 64l0 265.4 84.7-84.7L128 233.4l11.3 11.3L224 329.4 372.7 180.7 384 169.4l11.3 11.3L480 265.4 480 64 32 64zm0 310.6L32 448l73.4 0 96-96L128 278.6l-96 96zm352-160L150.6 448 480 448l0-137.4-96-96zM0 32l32 0 448 0 32 0 0 32 0 384 0 32-32 0L32 480 0 480l0-32L0 64 0 32zM160 144a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zm-64 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faArrowUpAZ = {
    prefix: 'fasl',
    iconName: 'arrow-up-a-z',
    icon: [
      576,
      512,
      ["sort-alpha-up"],
      'f15e',
      
      'M405.6 32l-4.2 9.5-80 180-1.1 2.5 35 0 14.2-32 93 0 14.2 32 35 0-1.1-2.5-80-180L426.4 32l-20.8 0zm42.7 128l-64.5 0L416 87.4 448.3 160zM171.3 44.7L160 33.4 148.7 44.7l-88 88L49.4 144 72 166.6l11.3-11.3L144 94.6 144 464l0 16 32 0 0-16 0-369.4 60.7 60.7L248 166.6 270.6 144l-11.3-11.3-88-88zM352 288l-16 0 0 32 16 0 99.5 0L340 445.4l-4 4.5 0 6.1 0 8 0 16 16 0 128 0 16 0 0-32-16 0-99.5 0L492 322.6l4-4.5 0-6.1 0-8 0-16-16 0-128 0z'
      
    ]
  };

  
    var faSortAlphaUp = faArrowUpAZ;
  

  
  

  var faStar = {
    prefix: 'fasl',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M374.6 164L306.1 34.3 288.1 0 270 34.3 201.5 164 57.1 189l-38.2 6.6 27 27.8L148.1 328.5 127.2 473.6 121.7 512l34.8-17.1 131.6-64.7 131.6 64.7L454.4 512l-5.5-38.4L428 328.5 530.2 223.4l27-27.8L519 189 374.6 164zM492 216.8l-86.9 89.4-11 11.3 2.2 15.6 17.8 123.5-111.9-55-14.1-6.9-14.1 6.9L162 456.5l17.8-123.5 2.2-15.6-11-11.3L84.1 216.8 207 195.5l15.5-2.7 7.3-13.9L288.1 68.6l58.2 110.3 7.3 13.9 15.5 2.7L492 216.8z'
      
    ]
  };

  

  
  

  var faLinkSimple = {
    prefix: 'fasl',
    iconName: 'link-simple',
    icon: [
      576,
      512,
      [],
      'e1cd',
      
      'M0 256C0 167.6 71.6 96 160 96l80 0 16 0 0 32-16 0-80 0C89.3 128 32 185.3 32 256s57.3 128 128 128l80 0 16 0 0 32-16 0-80 0C71.6 416 0 344.4 0 256zm576 0c0 88.4-71.6 160-160 160l-80 0-16 0 0-32 16 0 80 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-80 0-16 0 0-32 16 0 80 0c88.4 0 160 71.6 160 160zM152 240l272 0 16 0 0 32-16 0-272 0-16 0 0-32 16 0z'
      
    ]
  };

  

  
  

  var faChevronUp = {
    prefix: 'fasl',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 105.4l11.3 11.3 192 192L470.6 320 448 342.6l-11.3-11.3L256 150.6 75.3 331.3 64 342.6 41.4 320l11.3-11.3 192-192L256 105.4z'
      
    ]
  };

  

  
  

  var faUsers = {
    prefix: 'fasl',
    iconName: 'users',
    icon: [
      640,
      512,
      [],
      'f0c0',
      
      'M96 80a48 48 0 1 1 96 0A48 48 0 1 1 96 80zm128 0A80 80 0 1 0 64 80a80 80 0 1 0 160 0zm96 80a64 64 0 1 1 0 128 64 64 0 1 1 0-128zm0 160a96 96 0 1 0 0-192 96 96 0 1 0 0 192zM199.8 384l240.4 0L469 480l-298 0 28.8-96zM464 352l-288 0L137.6 480 128 512l33.4 0 317.2 0 33.4 0-9.6-32L464 352zM448 224l121.8 0 36 96 34.2 0L592 192l-148 0c2.6 10.2 4 21 4 32zM196 192L48 192 0 320l34.2 0 36-96L192 224c0-11 1.4-21.8 4-32zM464 80a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm128 0A80 80 0 1 0 432 80a80 80 0 1 0 160 0z'
      
    ]
  };

  

  
  

  var faBagShopping = {
    prefix: 'fasl',
    iconName: 'bag-shopping',
    icon: [
      448,
      512,
      ["shopping-bag"],
      'f290',
      
      'M160 96l0 32 128 0 0-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-32 64l-96 0 0 320 384 0 0-320-96 0 0 80 0 16-32 0 0-16 0-80-128 0 0 80 0 16-32 0 0-16 0-80zm0-32l0-32c0-53 43-96 96-96s96 43 96 96l0 32 96 0 32 0 0 32 0 320 0 32-32 0L32 512 0 512l0-32L0 160l0-32 32 0 96 0z'
      
    ]
  };

  
    var faShoppingBag = faBagShopping;
  

  
  

  var faCircleExclamation = {
    prefix: 'fasl',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm16-384l-32 0 0 16 0 128 0 16 32 0 0-16 0-128 0-16zM232 368l48 0 0-48-48 0 0 48z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faBars = {
    prefix: 'fasl',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 64l448 0 0 32L0 96 0 64zM0 224l448 0 0 32L0 256l0-32zM448 384l0 32L0 416l0-32 448 0z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faArrowProgress = {
    prefix: 'fasl',
    iconName: 'arrow-progress',
    icon: [
      512,
      512,
      [],
      'e5df',
      
      'M416 32l0 64 64 0 0-64-64 0zM384 0l32 0 64 0 32 0 0 32 0 64 0 32-32 0-64 0-32 0 0-32 0-64 0-32zM286 1.5l12.3 10.2 48 40L361 64 346.2 76.3l-48 40L286 126.5 265.5 102l12.3-10.2 14-11.7L32 80l0 160 464 0 16 0 0 16 0 192 0 16-16 0-80 0 0 16 0 32-32 0-64 0-32 0 0-32 0-64 0-32 32 0 64 0 32 0 0 32 0 16 64 0 0-160L16 272 0 272l0-16L0 64 0 48l16 0 275.8 0-14-11.7L265.5 26 286 1.5zM128 416l0 16 67.8 0-14.1-11.7L169.5 410 190 385.5l12.3 10.2 48 40L265 448l-14.7 12.3-48 40L190 510.5 169.5 486l12.3-10.2L195.8 464 128 464l0 16 0 32-32 0-64 0L0 512l0-32 0-64 0-32 32 0 64 0 32 0 0 32zm-32 0l-64 0 0 64 64 0 0-64zm224 0l0 64 64 0 0-64-64 0z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fasl',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M480 64L32 64l0 64 32 0 384 0 32 0 0-64zm0 96l-32 0L64 160l-32 0L0 160l0-32L0 64 0 32l32 0 448 0 32 0 0 32 0 64 0 32-32 0zM160 224l16 0 160 0 16 0 0 32-16 0-160 0-16 0 0-32zm288-32l32 0 0 256 0 32-32 0L64 480l-32 0 0-32 0-256 32 0 0 256 384 0 0-256z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faComments = {
    prefix: 'fasl',
    iconName: 'comments',
    icon: [
      640,
      512,
      [61670,128490],
      'f086',
      
      'M70.9 293l7.3-18.3L65.2 260C43.9 235.8 32 206.8 32 176c0-74.7 73.6-144 176-144s176 69.3 176 144s-73.6 144-176 144c-14.6 0-28.7-1.5-42.2-4.2l-6.8-1.4-6.7 1.6-99.9 23L70.9 293zM0 384l38-8.8 121.5-28c15.6 3.1 31.8 4.8 48.5 4.8c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176c0 39.4 15.3 75.8 41.2 105.1L14.5 347.8 0 384zm432 96c16.7 0 32.9-1.7 48.5-4.8l121.5 28 38 8.8-14.5-36.2-26.7-66.7C624.7 379.8 640 343.4 640 304c0-94.4-87.9-171.5-198.2-175.8c2.8 10.4 4.7 21.2 5.6 32.3C541.7 167 608 233.1 608 304c0 30.8-11.9 59.8-33.2 84l-13 14.8 7.3 18.3 18.4 46.1-99.9-23-6.7-1.6-6.8 1.4c-13.5 2.7-27.6 4.2-42.2 4.2c-68.2 0-123.6-30.7-153.1-73.3c-11 3-22.3 5.2-33.8 6.8C279 439.8 350 480 432 480z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fasl',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M235.3 267.3L224 278.6l-11.3-11.3-160-160L41.4 96 64 73.4 75.3 84.7 224 233.4 372.7 84.7 384 73.4 406.6 96l-11.3 11.3-160 160zm0 192L224 470.6l-11.3-11.3-160-160L41.4 288 64 265.4l11.3 11.3L224 425.4 372.7 276.7 384 265.4 406.6 288l-11.3 11.3-160 160z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faCircleMinus = {
    prefix: 'fasl',
    iconName: 'circle-minus',
    icon: [
      512,
      512,
      ["minus-circle"],
      'f056',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM160 240l-16 0 0 32 16 0 192 0 16 0 0-32-16 0-192 0z'
      
    ]
  };

  
    var faMinusCircle = faCircleMinus;
  



export {

  faBrainCircuit,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faCalendar,
  

  faChevronRight,
  

  faChevronLeft,
  

  faLinkHorizontalSlash,
  
  faChainHorizontalSlash,
  

  faPlus,
  
  faAdd,
  

  faChevronDown,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faFile,
  

  faArrowsFromLine,
  

  faGrid2Plus,
  

  faImages,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faSliders,
  
  faSlidersH,
  

  faBallot,
  

  faGear,
  
  faCog,
  

  faListTimeline,
  

  faArrowDownAZ,
  
  faSortAlphaAsc,
  
  faSortAlphaDown,
  

  faArrowDown19,
  
  faSortNumericAsc,
  
  faSortNumericDown,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faTrash,
  

  faOctagonExclamation,
  

  faArrowUp19,
  
  faSortNumericUp,
  

  faSpinnerThird,
  

  faCircleEllipsisVertical,
  

  faCalendarArrowUp,
  
  faCalendarUpload,
  

  faArrowsToLine,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faClipboardCheck,
  

  faFolders,
  

  faCalendarArrowDown,
  
  faCalendarDownload,
  

  faArrowUpRightFromSquare,
  
  faExternalLink,
  

  faPuzzlePiece,
  

  faSort,
  
  faUnsorted,
  

  faAddressCard,
  
  faContactCard,
  
  faVcard,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faImage,
  

  faArrowUpAZ,
  
  faSortAlphaUp,
  

  faStar,
  

  faLinkSimple,
  

  faChevronUp,
  

  faUsers,
  

  faBagShopping,
  
  faShoppingBag,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faBars,
  
  faNavicon,
  

  faArrowProgress,
  

  faBoxArchive,
  
  faArchive,
  

  faComments,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faCircleMinus,
  
  faMinusCircle,
  

};
